import React from 'react'
import PropTypes from 'prop-types'
import * as config from '../../config';
import InlineCard from '../inline-card/inline-card'
import './inline-related.scss'

const InlineRelated = ({ articles }) => {
  return (
    <div className="i-related">
      <aside className="i-related__wrapper">
        <div className="i-related__caption">
          <span className="i-related__caption-text">Related reviews</span>
        </div>

        {articles.map((article, i) => (
          <InlineCard
            key={i}
            title={article.title}
            introduction={article.introduction}
            image={article.image}
            slug={article.slug}
            url={config.siteUrl + article.slug}
          />
        ))}
      </aside>
    </div>
  )
};

InlineRelated.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    introduction: PropTypes.string,
    image: PropTypes.string,
    slug: PropTypes.string
  }))
};

export default InlineRelated



// WEBPACK FOOTER //
// ./src/components/inline-related/inline-related.js